import type { ApiError } from "@billing/shared";

export type Ok<T> = { ok: true; data: T };
export type Err = { ok: false; error: ApiError };
export type Result<T> = Ok<T> | Err;

export const Ok = <T>(data: T): Ok<T> => ({ ok: true, data });
export const Err = (error: ApiError): Err => ({ ok: false, error });
